import UriTemplate from 'uri-templates';
import {context} from "../constants/context";
import {halClient} from "../hal";

const addressList = {
    query(prms) {
        return new Promise((resolve, reject) => {
            const href = `/api/${context.apiVersion}/company/{company_id}/addresses/{post_code}`;
            const uri = new UriTemplate(href).fillFromObject({
                company_id: prms.company.id,
                post_code: prms.post_code
            });
            halClient.$get(uri, {}).then(addressList => resolve(addressList)
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    getAddress(prms) {
        return new Promise((resolve, reject) => {
            const href = `/api/${context.apiVersion}/company/{company_id}/addresses/address/{id}`;
            const uri = new UriTemplate(href).fillFromObject({company_id: prms.company.id, id: prms.id});
            halClient.$get(uri, {}).then(customerAddress => resolve(customerAddress)
                , (err) => {
                    return reject(err);
                }
            );
        });
    }
};

export {
    addressList
}
